import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "uk-container-large uk-margin-top border-outline" }
const _hoisted_2 = {
  class: "uk-grid-small",
  "data-uk-grid": ""
}
const _hoisted_3 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_4 = { class: "uk-inline uk-margin-top" }
const _hoisted_5 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_6 = { class: "uk-inline" }
const _hoisted_7 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_8 = { class: "uk-inline" }
const _hoisted_9 = { class: "uk-margin-remove-top uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_10 = { class: "uk-inline" }
const _hoisted_11 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_12 = { class: "uk-inline" }
const _hoisted_13 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_14 = { class: "uk-inline" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_17 = { class: "uk-inline" }
const _hoisted_18 = { class: "uk-margin-remove-top uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_19 = { class: "uk-inline" }
const _hoisted_20 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_21 = { class: "uk-inline" }
const _hoisted_22 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_23 = { class: "uk-inline" }
const _hoisted_24 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_25 = { class: "uk-inline" }
const _hoisted_26 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_27 = { class: "uk-inline" }
const _hoisted_28 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_29 = { class: "uk-inline" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_32 = { class: "uk-form-controls uk-inline" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_35 = { class: "uk-inline" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "uk-margin-remove-top uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_38 = { class: "uk-inline" }

import {getCurrentInstance, reactive} from "vue";
import Customer from "@/models/Customer";
import countryWorld from "@/shared/constants/countryWorld";
import countryRegion from "@/shared/constants/CountryRegion";
import Nationality from "@/shared/constants/Nationality";
import CustomerIdType from "@/shared/constants/CustomerIdType";
import {useStore} from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'NewCustormer',
  emits: ['customerSave'],
  setup(__props, { emit: __emit }) {

const country = countryWorld
const region = countryRegion
const nationality = Nationality
const cardIdType = CustomerIdType
const { $alert } = getCurrentInstance().appContext.config.globalProperties;
const emit = __emit

const store = useStore()
const customer = store.getters['booking/getCustomer']??null
const customerForm = reactive<Customer>({
  cust_birth_place:customer ===null?'':customer.cust_birth_place,
  cust_birthday:customer ===null?'':customer.cust_birthday,
  cust_city:customer ===null?'':customer.cust_city,
  cust_contact:customer ===null?'':customer.cust_contact,
  cust_country:customer ===null?'':customer.cust_country,
  cust_email:customer ===null?'':customer.cust_email,
  cust_date_of_entering_ivory_coast:customer ===null?'':customer.cust_date_of_entering_ivory_coast,
  cust_father_name:customer ===null?'':customer.cust_father_name,
  cust_firstname:customer ===null?'':customer.cust_firstname,
  cust_id_expiration_date:customer ===null?'':customer.cust_id_expiration_date,
  cust_job:customer ===null?'':customer.cust_job,
  cust_lastname:customer ===null?'':customer.cust_lastname,
  cust_mother_name:customer ===null?'':customer.cust_mother_name,
  cust_nationality:customer ===null?'':customer.cust_nationality,
  cust_place_residence:customer ===null?'':customer.cust_place_residence,
  cust_pseudonym:customer ===null?'':customer.cust_pseudonym,
  cust_sexe:customer ===null?'':customer.cust_sexe,
  cust_reference_id:customer ===null?'':customer.cust_reference_id,
  cust_type_id:customer ===null?'':customer.cust_type_id
})
const formValidator = ()=>{
  return customerForm.cust_lastname ==''
      ||customerForm.cust_firstname==''
      ||customerForm.cust_city==''
      ||customerForm.cust_birth_place==''
      ||customerForm.cust_contact==''
      ||customerForm.cust_country==''
      ||customerForm.cust_id_expiration_date==''
      ||customerForm.cust_job==''
      ||customerForm.cust_sexe==''
      ||customerForm.cust_reference_id==''
      ||customerForm.cust_place_residence==''
      ||customerForm.cust_type_id==''
}
const saveCustomer = ()=>{
  if (formValidator()){
    $alert.fire({
      title: 'Ooops!',
      text: "Les champs avec * sont obligatoire",
      icon: 'error',
      confirmButtonColor:'#D62F2F',
      confirmButtonText: 'Compris'
    })
  }else {
    store.dispatch('booking/saveCustomer', customerForm)
    store.dispatch('booking/saveNewCustomer',true)
    emit('customerSave')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[34] || (_cache[34] = _createElementVNode("h6", { class: "uk-heading-line uk-text-center uk-text-secondary uk-text-uppercase uk-text-bold" }, [
      _createElementVNode("span", null, "Enregistré ici vous si vous n'êtes jamais inscrit à cette plateforme. ")
    ], -1)),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Civilité*", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerForm.cust_sexe) = $event)),
            class: "uk-select uk-input uk-form-width-large uk-border-rounded csa-input"
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("option", { value: "M." }, "Monsieur", -1),
            _createElementVNode("option", { value: "Mme" }, "Madame", -1),
            _createElementVNode("option", { value: "Mle" }, "Mademoiselle", -1)
          ]))], 512), [
            [_vModelSelect, customerForm.cust_sexe]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[19] || (_cache[19] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: user"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerForm.cust_lastname) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Nom(s)*",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_lastname]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[20] || (_cache[20] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: user"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customerForm.cust_firstname) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Prénom(s)*",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_firstname]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[21] || (_cache[21] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Date d'anniversaire*", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerForm.cust_birthday) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Date d'anniversaire",
            type: "date",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_birthday]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[22] || (_cache[22] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: location"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((customerForm.cust_birth_place) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Lieu de naissance*",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_birth_place]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customerForm.cust_type_id) = $event)),
            class: "uk-select uk-input uk-form-width-large uk-border-rounded csa-input"
          }, [
            _cache[23] || (_cache[23] = _createElementVNode("option", {
              disabled: "",
              selected: ""
            }, "Type de pièce d'identité*", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cardIdType), (idType, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: idType,
                key: index
              }, _toDisplayString(idType), 9, _hoisted_15))
            }), 128))
          ], 512), [
            [_vModelSelect, customerForm.cust_type_id]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[24] || (_cache[24] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: credit-card"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customerForm.cust_reference_id) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Réference de la pièce*",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_reference_id]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[25] || (_cache[25] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Date d'expiration de la pièce*", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customerForm.cust_id_expiration_date) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Date d'expiration de la pièce",
            type: "date",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_id_expiration_date]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[26] || (_cache[26] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: phone"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((customerForm.cust_contact) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Contact*",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_contact]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _cache[27] || (_cache[27] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: location"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((customerForm.cust_place_residence) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Lieu de residence*",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_place_residence]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _cache[28] || (_cache[28] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: mail"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((customerForm.cust_email) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Email",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_email]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _cache[29] || (_cache[29] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: user"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((customerForm.cust_job) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Profession*",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_job]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _cache[30] || (_cache[30] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Pays*", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((customerForm.cust_country) = $event)),
            class: "uk-select uk-input uk-form-width-large uk-border-rounded csa-input"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(country), (cust_country) => {
              return (_openBlock(), _createElementBlock("option", {
                value: cust_country[4],
                key: cust_country[0]
              }, _toDisplayString(cust_country[4]), 9, _hoisted_30))
            }), 128))
          ], 512), [
            [_vModelSelect, customerForm.cust_country]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Ville/Region*", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((customerForm.cust_city) = $event)),
            class: "uk-select uk-input uk-form-width-large uk-border-rounded csa-input"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(region), (cust_city) => {
              return (_openBlock(), _createElementBlock("option", {
                value: cust_city,
                key: cust_city
              }, _toDisplayString(cust_city), 9, _hoisted_33))
            }), 128))
          ], 512), [
            [_vModelSelect, customerForm.cust_city]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _cache[32] || (_cache[32] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Nationalité*", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((customerForm.cust_nationality) = $event)),
            class: "uk-select uk-input uk-form-width-large uk-border-rounded csa-input"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nationality), (cust_nation) => {
              return (_openBlock(), _createElementBlock("option", {
                value: cust_nation,
                key: cust_nation
              }, _toDisplayString(cust_nation), 9, _hoisted_36))
            }), 128))
          ], 512), [
            [_vModelSelect, customerForm.cust_nationality]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[33] || (_cache[33] = _createElementVNode("label", {
            class: "uk-form-label",
            for: "form-horizontal-text"
          }, "Date d'entrée en cote d'ivoire*", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((customerForm.cust_date_of_entering_ivory_coast) = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Date d'entrée en cote d'ivoire",
            type: "date",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, customerForm.cust_date_of_entering_ivory_coast]
          ])
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "uk-button uk-button-large csa-btn",
      onClick: _cache[16] || (_cache[16] = ($event: any) => (saveCustomer()))
    }, "Valider")
  ]))
}
}

})